import { render, staticRenderFns } from "./Pep-statement-report-table.vue?vue&type=template&id=2a8c5d5c&scoped=true"
import script from "./Pep-statement-report-table.vue?vue&type=script&lang=js"
export * from "./Pep-statement-report-table.vue?vue&type=script&lang=js"
import style0 from "./Pep-statement-report-table.vue?vue&type=style&index=0&id=2a8c5d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c5d5c",
  null
  
)

export default component.exports